import domready from 'domready'
import AboutController from './controllers/about-controller'

export default function initFiltersIndexController () {
  domready(() => {
    const element = document.querySelector('.about')
    if (element) {
      // eslint-disable-next-line no-new
      new AboutController(element)
    }
  })
}
